function hasGetUserMedia(): boolean {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}

async function getUserMedia(
  constraints: MediaStreamConstraints = {
    video: true,
    audio: true,
  },
): Promise<MediaStream | undefined> {
  try {
    const windowStream = (window as any).stream;
    if (windowStream) {
      windowStream.getTracks().forEach((track: { stop: () => void }) => {
        track.stop();
      });
    }

    return await navigator.mediaDevices.getUserMedia(constraints);
  } catch (error) {
    console.error('Something went wrong while accessing media devices.', error);
  }
}

async function getConnectedDevices(): Promise<MediaDeviceInfo[]> {
  try {
    return await navigator.mediaDevices.enumerateDevices();
  } catch (error) {
    console.error('Something went wrong while getting connected devices.', error);
    return [];
  }
}

function revokeMediaAccess(): void {
  const windowStream = (window as any).stream;
  // Revoke camera and microphone access
  if (!windowStream) {
    return;
  }
  if (windowStream) {
    windowStream.getTracks().forEach((track: { stop: () => void }) => {
      track.stop();
    });
  }
}

export { hasGetUserMedia, getUserMedia, getConnectedDevices, revokeMediaAccess };
